import { useCoachQuery } from '@/features/home/queries';
import { useEnvUrls } from '@/libs/config';
import { useSessionStore } from '@/stores/session-store';
import { useMemo, useState } from 'react';

export function useDashboard() {
  const user = useSessionStore(state => state.user);
  const { data: coach } = useCoachQuery(user?.uid);
  const [now, setNow] = useState(() => new Date());
  const { pictureUrl: pictureUrlBase } = useEnvUrls();

  const avatarSource = useMemo(() => {
    const pictureUrl = pictureUrlBase?.trim();
    const uri =
      pictureUrl && coach?.id
        ? `${pictureUrl}${coach.id}.jpg?alt=media&updated_at=${coach.updated_at}`
        : undefined;
    if (!uri) return undefined;
    return { uri };
  }, [coach?.id, coach?.updated_at, pictureUrlBase]);

  const userFirstName = useMemo(() => {
    const name = coach?.firstname ?? '';
    return name ?? 'Coach';
  }, [coach?.firstname]);

  const userName = useMemo(() => {
    const name = coach?.name ?? user?.displayName ?? 'Coach';
    return name ?? 'Coach';
  }, [coach?.name, user?.displayName]);

  const hasActiveSession = useMemo(
    () => Boolean(coach?.active_session_id && coach.active_session_id.trim() !== ''),
    [coach?.active_session_id],
  );

  return {
    userFirstName,
    userName,
    hasActiveSession,
    avatarSource,
    now,
    setNow,
  };
}
